import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Request from '../../services/request';
import { throttle } from '../../services/utilityFunctions';
import translate from '../../commonComponents/translate';
import FormGroup from '../../commonComponents/forms/FormGroup';
import FormLabel from '../../commonComponents/forms/FormLabel';

function DiscountInput({ t, onChange }) {
  const [isValid, setIsValid] = useState(true);

  const checkValidity = useCallback(
    throttle(code => {
      if (code) {
        new Request()
          .get(`/discount/${code}`)
          .done(({ data }) => {
            setIsValid(true);
            onChange(data);
          })
          .fail(() => {
            setIsValid(false);
            onChange(null);
          });
      } else {
        setTimeout(() => {
          setIsValid(true);
          onChange(null);
        }, 300);
      }
    }, 300),
    [onChange],
  );

  return (
    <FormGroup className={cx('row', { 'has-danger': !isValid })}>
      <FormLabel
        id="discountInput"
        label={t('discountCoupon')}
        className="col-lg-3"
      />
      <div className="col-lg-4">
        <input
          id="discountInput"
          className="form-control m-input"
          type="text"
          onChange={({ currentTarget }) => checkValidity(currentTarget.value)}
        />
        <div className="form-control-feedback">
          {!isValid ? t('error_noDiscountMatchingCode') : ''}
        </div>
      </div>
    </FormGroup>
  );
}

DiscountInput.propTypes = {
  t: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default translate(DiscountInput);
